import { gql } from '@apollo/client';

export const SEND_MESSAGE = gql`
  mutation Chat_chatPost(
    $conversationId: String!
    $content: String!
    $projectId: Id!
  ) {
    chat_chatPost(
      conversationId: $conversationId
      content: $content
      projectId: $projectId
    ) {
      id
      answer
      question
      createdAt
    }
  }
`;

export const SEND_MESSAGE_BOOLEAN_QUERY = gql`
  mutation Chat_chatPostBoolean(
    $conversationId: String!
    $content: String!
    $projectId: Id!
  ) {
    chat_chatPostBoolean(
      conversationId: $conversationId
      content: $content
      projectId: $projectId
    ) {
      id
      response
      include
      exclude
      createdAt
      question
    }
  }
`;
